import { Image, Typography } from '@mantine/core';
import { useEffect, useState } from 'react';
import ReactMarkdown, { defaultUrlTransform } from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { api } from '../lib/api';
import classes from './Markdown.module.css';

// Картинка из файла урока: ![подпись](attachment:ID), грузится с токеном, прямой ссылки на хранилище нет
function AttachmentImage({ path, alt }: { path: string; alt: string }) {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    let revoke: string | null = null;
    api.blob(path).then((b) => {
      revoke = URL.createObjectURL(b);
      setUrl(revoke);
    }).catch(() => setUrl(null));
    return () => {
      if (revoke) URL.revokeObjectURL(revoke);
    };
  }, [path]);
  return url ? <Image src={url} alt={alt} radius="md" my="sm" /> : null;
}

const keepAttachment = (url: string) => (url.startsWith('attachment:') ? url : defaultUrlTransform(url));

// Сырой HTML в уроках не рендерится (react-markdown без rehype-raw): защита от XSS в контенте.
// attachmentPath задаёт, откуда брать файлы: у сотрудника - через его назначение, у админа - напрямую.
export function Markdown({ children, attachmentPath }: { children: string; attachmentPath?: (id: number) => string }) {
  return (
    <Typography className={classes.md}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        urlTransform={keepAttachment}
        components={{
          a: (p) => <a {...p} target="_blank" rel="noopener noreferrer" />,
          img: ({ src, alt }) => {
            const s = typeof src === 'string' ? src : '';
            if (s.startsWith('attachment:')) {
              const id = Number(s.slice('attachment:'.length));
              return attachmentPath && id ? <AttachmentImage path={attachmentPath(id)} alt={alt ?? ''} /> : null;
            }
            return <img src={s} alt={alt ?? ''} style={{ maxWidth: '100%', borderRadius: 8 }} />;
          },
        }}
      >
        {children}
      </ReactMarkdown>
    </Typography>
  );
}
